import { render } from "./IndexOperation.vue?vue&type=template&id=08464a6b"
import script from "./IndexOperation.vue?vue&type=script&lang=js"
export * from "./IndexOperation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__